import './ReactHTMLTag.scss'
import { Container, ContainerState } from '@adobe/aem-react-editable-components'

import { ReactHTMLTagProps } from './types'
import IsInEditorText from '../shared/IsInEditorText'

/* PROPS  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

class ReactHTMLTag extends Container<ReactHTMLTagProps, ContainerState> {
  constructor(props: ReactHTMLTagProps) {
    super(props)
  }

  get columnControlProps() {
    const attrs = this.containerProps
    attrs.className = `${attrs.className} ${this.props.baseCssClass}`
    attrs['data-cmp-is'] = 'htmltag'
    return attrs
  }

  render(): JSX.Element {
    const {
      bootstrapclasses,
      customid,
      detailstext,
      figuretext,
      summarytext,
      videosrc,
      videotype,
      progressvalue,
      progressmax,
      isInEditor,
      id = ''
    } = this.props
    let { tags: HTMLTag } = this.props
    let classes,
      tagId,
      max,
      src,
      text,
      type,
      value,
      hasControls = false

    switch (HTMLTag) {
      case 'customid':
        HTMLTag = 'div'
        tagId = customid
        break
      case 'details':
        text = detailstext
        break
      case 'div':
        if (bootstrapclasses) classes = bootstrapclasses
        break
      case 'summary':
        text = summarytext
        break
      case 'video':
        src = videosrc
        type = videotype
        hasControls = true
        break
      case 'progress':
        value = progressvalue
        max = progressmax
        break
      case 'caption':
        HTMLTag = 'figcaption'
        classes = 'container word-wrap '
        text = figuretext
        break
      default:
        break
    }

    return (
      <div data-testid={`react-htmltag-container`} id={id}>
        {IsInEditorText(isInEditor, 'React HTML Tag')}
        {HTMLTag && (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          <HTMLTag
            role={HTMLTag}
            data-testid={`react-htmltag`}
            className={classes}
            value={value}
            max={max}
            id={tagId}
            controls={hasControls}
          >
            {text}
            {HTMLTag === 'video' && <source src={src} type={type}></source>}
            {this.childComponents}
            {this.placeholderComponent}
          </HTMLTag>
        )}
      </div>
    )
  }
}
export default ReactHTMLTag
